import type { Theme } from '@emotion/react'

import * as styles from './checkbox-icon.styles'

type Props = {
  isChecked: boolean
  isIndeterminate?: boolean
  isDisabled?: boolean
  error?: boolean
  className?: string
}

const check = (
  <svg fill="none" height="10" viewBox="0 0 12 10" width="12">
    <path d="M4.16623 7.33309L10.4481 1.0924C10.739 0.802535 11.2104 0.802535 11.5013 1.0924C11.7921 1.38226 11.7921 1.85221 11.5013 2.14207L4.69279 8.9076C4.40198 9.19746 3.93048 9.19746 3.63967 8.9076L0.498716 5.78726C0.207907 5.4974 0.207907 5.02744 0.498716 4.73758C0.789526 4.44772 1.26102 4.44772 1.55183 4.73758L4.16623 7.33309Z" />
  </svg>
)

const minus = (
  <svg fill="none" height="2" viewBox="0 0 12 2" width="12">
    <path
      d="M12 1C12 1.41421 11.6642 1.75 11.25 1.75H0.75C0.335786 1.75 0 1.41421 0 1C0 0.585786 0.335786 0.25 0.75 0.25L11.25 0.25C11.6642 0.25 12 0.585786 12 1Z"
      fill="white"
    />
  </svg>
)

export const CheckboxIcon = ({
  isChecked,
  isIndeterminate = false,
  isDisabled = false,
  error = false,
  className,
}: Props) => {
  const checkedStyles = (theme: Theme) => [
    styles.root(theme),
    isDisabled ? styles.checkedDisabled(theme) : styles.checked(theme),
  ]

  const uncheckedStyles = (theme: Theme) => [
    styles.root(theme),
    isDisabled && styles.uncheckedDisabled(theme),
    error && styles.uncheckedError(theme),
  ]

  const indeterminateStyles = (theme: Theme) => [
    styles.root(theme),
    styles.checked(theme),
  ]

  if (isIndeterminate) {
    return (
      <div className={className} css={indeterminateStyles}>
        {minus}
      </div>
    )
  }

  if (isChecked) {
    return (
      <div className={className} css={checkedStyles}>
        {check}
      </div>
    )
  }

  return <div className={className} css={uncheckedStyles} />
}
